import React from 'react'
import { TextArea } from '@arnsbogroup/react-voicearchive'

const Overview = ( {supplier, onChangeHandler, currentUser} ) => {
    if (!supplier) {
        return null
    }
    return (
        <div className='p-4'>
            <div className='grid grid-cols-1 gap-6 md:grid-cols-2 order-3 md:order-none'>
                <div>
                    <TextArea
                        rows={4}
                        label="Work experience"
                        description="Any experience or references to previous work"
                        defaultValue={supplier.description}
                        placeholder="Work experience"
                        onBlur={({ target: { value } }) => {
                            onChangeHandler({ ...supplier, description: value })
                        }}
                    />
                </div>
                <div>
                    <TextArea
                        rows={4}
                        label="Internal Comment"
                        description="Helpful information for internal use only"
                        defaultValue={supplier.commentsinternal}
                        placeholder="Internal Comment"
                        onBlur={({ target: { value } }) => {
                            onChangeHandler({ ...supplier, commentsinternal: value })
                        }}
                    />
                </div>
                <div>
                    <TextArea
                        rows={4}
                        label="Note"
                        description="Any information or extra wishes from the supplier"
                        defaultValue={supplier.note}
                        placeholder="Note"
                        onBlur={({ target: { value } }) => {
                            onChangeHandler({ ...supplier, note: value })
                        }}
                    />
                </div>
                <div>
                    <TextArea
                        rows={4}
                        label="Additional Description"
                        description="Description regarding the supplier like ethnicity etc."
                        defaultValue={supplier.additional_description}
                        placeholder="Additional Description"
                        onBlur={({ target: { value } }) => {
                            onChangeHandler({ ...supplier, additional_description: value })
                        }}
                    />
                </div>
                <div>
                    <TextArea
                        rows={4}
                        label="Skills and Setup"
                        description="Description regarding the supplier's technical setup."
                        defaultValue={supplier.live_session_notes}
                        placeholder="Technical Setup"
                        disabled
                    />
                </div>
                <div>
                    <TextArea
                        rows={4}
                        label="Supplier Voice"
                        description="Description of supplier's voice"
                        defaultValue={supplier.commentsexternal}
                        placeholder="Technical Setup"
                        disabled
                    />
                </div>
            </div>
        </div>
    )
}

export default Overview
